import { Address } from "@msuite/ui/address";
import { ContentCard } from "@msuite/ui/content-card";
import { Icon } from "@msuite/ui/icons";
import { StateTag } from "@msuite/ui/tag";
import type { Nullable, Tables } from "@msuite/utils/types";
import { OrganizationAvatar } from "@/components/cards";
import { usePartnershipDirection } from "@/hooks/use-partnership-direction";

/** Props Interface */
interface OrganizationHeaderProps {
	organization: Nullable<Tables<"organizations">>;
	partnerships: Array<Tables<"organizationPartnerships">>;
}

export function OrganizationHeader({ organization, partnerships }: OrganizationHeaderProps) {
	/** Hooks */
	const { getDirectionLabel } = usePartnershipDirection();

	/** Computed */
	const name = `${organization?.name || ""}`.trim();

	/** Render */
	return (
		<ContentCard
			title={name}
			icon={() => {
				if (!organization?.id) return <Icon name="Replace" />;
				return <OrganizationAvatar orgId={organization?.id} />;
			}}
			identifier={organization?.id}
			isCollapsible={false}
			defaultIsOpen={false}
		>
			<div className="justify-between h-stack">
				{organization && <Address item={organization} />}
				<div className="gap-4 h-stack">
					{partnerships.map((partnership) => (
						<div
							key={partnership.id}
							className="gap-2 h-stack"
						>
							<span className="label">{getDirectionLabel(partnership, name)}</span>
							<StateTag state={partnership.state} />
						</div>
					))}
				</div>
			</div>
		</ContentCard>
	);
}
